import { useTranslation } from "react-i18next";
import { useApplyCouponMutation } from "../api/cartApi";
import { useMutationWithFeedback } from "../../../../common/hooks/hooks";

/**
 * A custom hook to encapsulate the logic for applying a coupon to the cart.
 */
export const useApplyCoupon = () => {
  const { t } = useTranslation();
  const [applyCouponMutation, mutationResult] = useApplyCouponMutation();

  const { trigger: handleApplyCoupon, isLoading: isApplying } =
    useMutationWithFeedback({
      mutation: [applyCouponMutation, mutationResult],
      loadingMessage: t(
        "feedback.cart.coupon.applyLoading",
        "Applying coupon..."
      ),
      successMessage: t(
        "feedback.cart.coupon.applySuccess",
        "Coupon applied successfully!"
      ),
      errorMessages: {
        default: t(
          "feedback.cart.coupon.applyError",
          "Failed to apply coupon. Please try again."
        ),
      },
    });

  return { handleApplyCoupon, isApplying };
};
